import { Component, ViewChild, OnInit, AfterViewInit, AfterViewChecked, ElementRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, AfterContentChecked } from '@angular/core'
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { MenuItems } from './menuItems.service';

import { environment } from '../../environments/environment';
import { AppService } from '../app.service';
import { APP_Constants } from '../app.constant';
import {TranslateService} from '@ngx-translate/core';
import { CookieService } from "ngx-cookie-service";

@Component({
    selector: 'app-app-nav-bar',
    templateUrl: './app-nav-bar.component.html',
    styleUrls: ['./app-nav-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppNavBarComponent implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy {
  subsOpenedChange: Subscription;
  showHeader: boolean = false;
  routerSubscription: any = null;
  customerSubscription: any = null;
  isMultilanguageAvailable: any;
  isShowDashboard: boolean = environment.showDashboard;
  menuUrlArray : any;
  navigationSubscription : any = null;
  currentUrl : any = location.pathname;
  isContactAvailable = false;
  showCookieBanner = false;
  isMobileSidenavOpen = false;
  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }
  @ViewChild('drawer', {static: true, read: ElementRef}) public drawer: ElementRef;
  @ViewChild('customerThemeToolbar', {static: false, read: ElementRef}) customerThemeToolbar: ElementRef;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  @ViewChild('globleMessageBanner', { static: false, read: ElementRef }) globleMessageBanner: ElementRef;
  dynamicHeightOfBanner: any = 0;
  globleMessageVisible: any = environment.globalBannerMessage;
  constructor(private appService: AppService, private changeDetector: ChangeDetectorRef, private router: Router, private breakpointObserver: BreakpointObserver, public menuItems: MenuItems,public translate: TranslateService, public cookieService: CookieService) {
    this.routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event['url'] == '/login' || event['url'] == '/' || event['url'] == '/logout') {
          this.showHeader = false;
        } else {
          this.showHeader = true;
        }
        this.currentUrl = event.url;
      }
    });
  }
  ngOnInit() {
    if(environment.globalBannerMessage && environment.maintenanceEndTime <= this.appService.formatcreatedDateUTC(new Date()))
    {
      this.globleMessageVisible = false;
    }
    this.translate.setDefaultLang('EN');
  }

  toggleDrawer() {
    this.isMobileSidenavOpen = !this.isMobileSidenavOpen;
  }

  closeMobileSidenav() {
    this.isMobileSidenavOpen = false;
  }

  selected: boolean = false;

  navigateURLs(data) {
    this.selected = true;
    if(environment.showDashboard && data !== 'profile' && data !== '/logout'){
      this.router.navigateByUrl('/dashboard');
    } else if (data !== '#') {
      if (data === '/logout' && environment.isSingleSignOn) {
        // NCP-14715:start - Passing flag for logout mode while user click on logout menu option
        this.appService.azureLogout(true);
      }
      else {
        this.router.navigateByUrl(data);
      }
    }
  }

  userType;

  multipleCustomer: boolean = false;
  logo;
  logoM;
  logoS;
  defaultLogo;
  customerCode;
  customerTheme: boolean = false;

  ngAfterViewInit() {
    this.isMultilanguageAvailable = this.appService.checkMultiLangSupport();
    this.isContactAvailable = this.appService.checkContactPage();
    this.defaultLogo = "../assets/theme/DHL" + "/logo.svg";
    let adminMenuDetails = {
      label: 'Menu_Items.configuration', icon: 'settings', link: '/superuser', rights: 'admin'
    }
    let adminMenuDetailsRO = {
      label: 'Menu_Items.configurationRO', icon: 'settings', link: '/superuserreadonly', rights: 'admin'
    }
    let adminBulkUserMenuDetails = {
      label: 'Menu_Items.bulk_user_Config', icon: 'settings',iconType: 'IMAGE', iconUrl: '../../assets/images/bulk-config.svg', link: '/superuser/bulk', rights: 'admin'
    }
    let templateMenuDetails = {
      label: 'Menu_Items.template_Mang', icon: 'settings',iconType: 'IMAGE', iconUrl: '../../assets/images/template-management.svg', link: '/templatemanagement', rights: 'admin'
    }
    let rateEnquiryMenuDetails = {
      label: 'Rate Lookup', icon: 'local_offer', rights: 'user', link: '/ratelookup'
    }
    let contactUsDetails = {
      label: 'Contact Us', icon: 'contact_support', rights: 'user', link: '/contact'
    }
    let customerOnboardingMenu = {
      label: 'Customer', icon: 'library_add', rights: 'user', link: '/customer'
    }
    let ordersMenu = {
      label: 'Menu_Items.orders', icon: 'shopping_cart', rights: 'user', link: '/orders'
    }
    let purchaseOrderMenu = {
      label: 'Menu_Items.purchase_orders', icon: 'shopping_bag', rights: 'user', link: '/orders/purchaseorders'
    }
    let vechicleorderMenu = {
      label: 'Menu_Items.vechicle_orders', icon: 'shopping_bag', rights: 'user', link: '/orders/purchaseorders'
    }
    let shipmentMenu = {
      label: 'Ship Confirm',icon: 'truck', iconType: 'IMAGE', iconUrl: '../../assets/icons/icons-truck.svg', link: '/shipments', rights: 'user'
    }
    let mrnMenu = {
      label: 'MRN', icon: 'guard', iconType: 'IMAGE', iconUrl: '../../assets/icons/icons-guard.svg', link: '/mrnlisting', rights: 'user'
    }
    let itnMenu = {
      label: 'ITN', icon: 'guard', iconType: 'IMAGE', iconUrl: '../../assets/icons/icons-guard.svg', link: '/itnlisting', rights: 'user'
    }
    let schemaValidationMenu = {
      label: 'Schema Validation', icon: 'shopping_bag', rights: 'user', link: '/schemavalidation'
    }
    let selfConFigMenuOption = {
      label: 'Self Service Config',icon: 'settings',iconType: 'IMAGE', iconUrl: '../../assets/images/self-config.svg', link: '#', rights: 'admin',
      subMenu: [
        { label: 'UI Config', icon: 'settings', rights: 'admin', link: '/selfServiceListing' },
        { label: 'BE Config', icon: 'settings', rights: 'admin', link: '/selfServiceListing/backend' },
        { label: 'Pending Config', icon: 'settings', rights: 'admin', link: '/selfServiceListing/selfconfigdraft' },
         ]
    }
    
    let trainingUploadMenu = {
      label: 'Training Upload', icon: 'cloud_upload', rights: 'user', link: '/trainingupload'
    } 

    let BusinessObjectOrdersMenu = {
      label: 'Orders', icon: 'shopping_cart', rights: 'user', link: '/business-object/orders'
    }
    // let BusinessObjectOrderUploadMenu = {
    //   label: 'Order upload', icon: 'shopping_cart', rights: 'user', link: '/business-object/upload'
    // }
    let cancelOrderMenu = {
      label: 'Orders', icon: 'remove_shopping_cart', rights: 'user', link: '/orders/cancel'
    }
    let dataUploadMenu = {
      label: 'Upload', icon: 'cloud_upload', rights: 'user', link: '/upload'
    }
    let uploadCsvMenu = {
      label: 'Upload CSV', icon: 'cloud_upload', rights: 'user', link: '/upload_csv'
    }
    let jlrdataupload = {
      label: 'Data Load', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        { label: 'File Upload', icon: 'cloud_upload', rights: 'user', link: '/business-object/fileupload/dailyfiles' },
        { label: 'Daily File Listing', icon: 'cloud_upload', rights: 'user', link: '/business-object/keep' },
        { label: 'DSDB Files Listing', icon: 'cloud_upload', rights: 'user', link: '/business-object/dsdbfileslisting' },
        { label: 'ODM Inbound file Listing', icon: 'cloud_upload', rights: 'user', link: '/business-object/inboundfileslisting' },
        { label: 'Outbound Order Files Listing', icon: 'cloud_upload', rights: 'user', link: '/business-object/outboundorderfileslisting' },
      ]
    }
    let jlrpartsandpackaginglisting = {
      label: 'Parts & Packaging', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        //{label: 'Item', icon: 'cloud_upload', rights: 'user', link: '/business-object/itemlisting'},
        { label: 'PSP', icon: 'cloud_upload', rights: 'user', link: '/business-object/psplisting' },
        { label: 'PSP Pack', icon: 'cloud_upload', rights: 'user', link: '/business-object/psppacklisting' },
        { label: 'Pack', icon: 'cloud_upload', rights: 'user', link: '/business-object/packinglisting' },
        { label: 'Raw Part', icon: 'cloud_upload', rights: 'user', link: '/business-object/partslisting' },
        { label: 'Raw container', icon: 'cloud_upload', rights: 'user', link: '/business-object/containerlisting' },
        { label: 'Raw Part Container', icon: 'cloud_upload', rights: 'user', link: '/business-object/partcontainerlisting' },
        { label: 'Raw SAP Part', icon: 'cloud_upload', rights: 'user', link: '//business-object/sappartlisting' },
        { label: 'Part Hazardous Clasfication', icon: 'cloud_upload', rights: 'user', link: '/business-object/parthazardouslisting' },
        //{ label: 'UK Packaged Item', icon: 'cloud_upload', rights: 'user', link: '/business-object/ukpackageditemlisting'},
        //{ label: 'EU Packaged Item', icon: 'cloud_upload', rights: 'user', link: '/business-object/eupackageditemlisting'},
      ]
    }
    let jlrLocationandcontacts = {
      label: 'Locations & Contacts', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        { label: 'Location', icon: 'cloud_upload', rights: 'user', link: '/business-object/locationlisting' },
        { label: 'Deck Location Pseudo', icon: 'cloud_upload', rights: 'user', link: '/business-object/decklocationlisting' },
        { label: 'Psuedo Supplier Location Code', icon: 'cloud_upload', rights: 'user', link: '/business-object/psuedosupplierlocationCodelisting' },
        { label: 'SAP Plant', icon: 'cloud_upload', rights: 'user', link: '/business-object/sapplantlisting' },
        { label: 'Contact', icon: 'cloud_upload', rights: 'user', link: '/business-object/contactlisting' },
        { label: 'Notification group', icon: 'cloud_upload', rights: 'user', link: '/business-object/notificationgrouplisting' },
        { label: 'EU Truck Delivery Point', icon: 'cloud_upload', rights: 'user', link: '/business-object/eutruckdeliverypoinlisting' },
      ]
    }
    let jlrTransport = {
      label: 'Transport', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        { label: 'Route Transport Path', icon: 'cloud_upload', rights: 'user', link: '/business-object/routetransportpathlisting' },
        { label: 'Route Transport Path Template', icon: 'cloud_upload', rights: 'user', link: '/business-object/routetransportpathtemplatelisting' },
        //			{ label: 'Transport Path', icon: 'cloud_upload', rights: 'user', link: '/business-object/transportpathlisting'},
        { label: 'Raw EU Strat Plan', icon: 'cloud_upload', rights: 'user', link: '/business-object/raweustrartplanlisting' },
        { label: 'Raw EU Strat Plan Csv', icon: 'cloud_upload', rights: 'user', link: '/business-object/raweustrartplancsvlisting' },
        { label: 'UK Tractor Group', icon: 'cloud_upload', rights: 'user', link: '/business-object/uktractorgrouplisting' },
        { label: 'EU contingency Plan', icon: 'cloud_upload', rights: 'user', link: '//business-object/eucontingencyplanlisting' },
        { label: 'Raw UK Strat Plan', icon: 'cloud_upload', rights: 'user', link: '/business-object/rawukstratplanlisting' },
        //{label: 'UK Route Movement', icon: 'cloud_upload', rights: 'user', link: '/business-object/ukroutemovementlisting'},
        { label: 'Route Movement Template', icon: 'cloud_upload', rights: 'user', link: '/business-object/routemovementtemplatelisting' },
        { label: 'Route Family Template', icon: 'cloud_upload', rights: 'user', link: '/business-object/routefamilytemplatelisting' },
        { label: 'Master Route Family', icon: 'cloud_upload', rights: 'user', link: '/business-object/masterroutefamilylisting' },
        { label: 'Route Movement Call Template', icon: 'cloud_upload', rights: 'user', link: '/business-object/routemovementcalltemplatelisting' },
        { label: 'Service Provider', icon: 'cloud_upload', rights: 'user', link: '/business-object/serviceproviderlisting' },
        { label: 'UK Reference Number', icon: 'cloud_upload', rights: 'user', link: '/business-object/ukreferencenumberlisting' },
        { label: 'Equipment', icon: 'cloud_upload', rights: 'user', link: '/business-object/equipmentlisting' },
        { label: 'Service', icon: 'cloud_upload', rights: 'user', link: '/business-object/servicelisting' },
        { label: 'Service Type', icon: 'cloud_upload', rights: 'user', link: '/business-object/servicetypelisting' },
      ]
    }
    let jlrSchedule = {
      label: 'Schedule', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        { label: 'Raw Schedule', icon: 'cloud_upload', rights: 'user', link: '/business-object/scheduledailylisting' },
      ]
    }
    let jlrFinance = {
      label: 'Finance', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        { label: 'Rate Book', icon: 'cloud_upload', rights: 'user', link: '/business-object/ratebooklisting' },
        { label: 'Rate', icon: 'cloud_upload', rights: 'user', link: '/business-object/ratelisting' },
        { label: 'GL Code', icon: 'cloud_upload', rights: 'user', link: '/business-object/glcodelisting' },
      ]
    }
    let jlrOrders = {
      label: 'Orders', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        { label: 'ODM Strat Plan', icon: 'cloud_upload', rights: 'user', link: '/business-object/odmstratplanlisting' },
        { label: 'ODM Order Line', icon: 'cloud_upload', rights: 'user', link: '/business-object/odmorderlinelisting' },
        { label: 'ODM Schedule', icon: 'cloud_upload', rights: 'user', link: '/business-object/odmschedulelisting' },
        { label: 'ODM ASN', icon: 'cloud_upload', rights: 'user', link: '/business-object/odmasnlisting' },
        { label: 'ODM Shipment Order', icon: 'cloud_upload', rights: 'user', link: '/business-object/odmshipmentorderlisting' },
        { label: 'ODM Shipment Control', icon: 'cloud_upload', rights: 'user', link: '/business-object/Odmshipmentcontrollisting' },
        { label: 'ODM Daily Order Process', icon: 'cloud_upload', rights: 'user', link: '/business-object/odmdailyorderprocesslisting' },
      ]
    }
    let jlrAdmin = {
      label: 'Admin', icon: 'cloud_upload', rights: 'user', link: '#',
      subMenu: [
        //			{label: 'Business Entity', icon: 'cloud_upload', rights: 'user', link: '/business-object/businessentitylisting'},
        { label: 'Day Offsets', icon: 'cloud_upload', rights: 'user', link: '/business-object/dayoffsetslisting' },
        { label: 'Parameters', icon: 'cloud_upload', rights: 'user', link: '/business-object/parameterslisting' },
        { label: 'Process Control', icon: 'cloud_upload', rights: 'user', link: '/business-object/processcontrollisting' },

      ]
    }
    let verifyOrderMenu = {
      label: 'Verify', iconType: 'IMAGE', iconUrl: '../../assets/images/application-menu.svg#svgView(viewBox(0,60,24,24))', icon: 'icons-verification', rights: 'user', link: '/business-object/verification'
    }
    let quotationMenu = {
      label: 'Quotation', iconType: 'IMAGE', iconUrl: '../../assets/images/application-menu.svg#svgView(viewBox(0,30,24,24))', icon: 'icons-verification', rights: 'user', link: '/business-object/quotation'
    }
    let locationMenu = {
      label: 'Location', iconType: 'IMAGE', iconUrl: '../../assets/images/application-menu.svg#svgView(viewBox(0,0,24,24))', icon: 'icons-verification', rights: 'user', link: '/business-object/location'
    }

    let draftOrderMenu = {
      label: 'Draft Order', iconType: 'IMAGE', iconUrl: '../../assets/images/application-menu.svg#svgView(viewBox(0,90,24,24))', icon: 'icons-verification', rights: 'user', link: '/orders/draft'
    }

    let carrierMenu = {
      label: 'Registration Listing', iconType: 'IMAGE', iconUrl: '../../assets/images/application-menu.svg#svgView(viewBox(0,120,24,24))', icon: 'icons-verification', rights: 'user', link: '/carrier'
    }

    if (localStorage.customerList && JSON.parse(localStorage.customerList).length > 0) {
      this.multipleCustomer = true;
    } else {
      this.multipleCustomer = false;
    }

    this.customerSubscription = this.appService._switchCustomerSubject.subscribe(res => {
      if (res && res.length > 0)
        this.multipleCustomer = true;
      else
        this.multipleCustomer = false;
    });

    this.navigationSubscription = this.appService._navigationSubject.subscribe(res => {
      if (res) {
        // theme
        this.isMultilanguageAvailable = this.appService.checkMultiLangSupport();
        this.isContactAvailable = this.appService.checkContactPage();
        var cssId = 'dhlTheme';
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        if (!JSON.parse(localStorage.getItem('alwaysUseDHLTheme'))) {        // change with alwaysUseDHlTheme
          this.customerTheme = true;

          link.href = '../assets/theme/' + localStorage.getItem('customerCode') + '/theme.css';
          link.media = 'all';
          head.appendChild(link);

          this.customerCode = localStorage.getItem('customerCode');
          // this.logo = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoD.jpg";    // get svg image
          // this.logo = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoD.jpg";
          // this.logoM = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoM.jpg";
          // this.logoS = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoS.jpg";

          if(localStorage.getItem('logoD')) this.logo = localStorage.getItem('logoD');
          else this.logo = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoD.jpg";

          if(localStorage.getItem('logoM')) this.logoM = localStorage.getItem('logoM');
          else this.logoM = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoM.jpg";

          if(localStorage.getItem('logoS')) this.logoS = localStorage.getItem('logoS');
          else this.logoS = "../assets/theme/" + localStorage.getItem('customerCode') + "/logoS.jpg";
        } else {
          this.customerTheme = false;

          link.href = '../assets/theme/DHL/theme.css';
          link.media = 'all';
          head.appendChild(link);

          this.customerCode = localStorage.getItem('customerCode');
          this.logo = "../assets/theme/DHL/logo.svg";
        }
        // theme

        let newMenu = [...APP_Constants.menuItems];
        let hasShipment = res.includes(APP_Constants.MENU_SHIPMENT);
        let hasMrnListing = res.includes(APP_Constants.MENU_MRNLISTING);
        let hasItnListing = res.includes(APP_Constants.MENU_ITN_LISTING);
        
        res.forEach(element => {
          if (element === APP_Constants.MENU_SHIPMENT || element === APP_Constants.MENU_MRNLISTING || element === APP_Constants.MENU_ITN_LISTING)
            return;
          if (element === APP_Constants.MENU_ORDER) {
            if (hasItnListing) newMenu.unshift(itnMenu);
            if (hasMrnListing) newMenu.unshift(mrnMenu);
            if (hasShipment) newMenu.unshift(shipmentMenu);
            newMenu.unshift(ordersMenu);
          }
          else if (element === APP_Constants.MENU_COX_ORDER) {
            // newMenu.unshift(BusinessObjectOrderUploadMenu);
            newMenu.unshift(BusinessObjectOrdersMenu);
          }
          else if (element === APP_Constants.MENU_PURCHASEORDER) {
            newMenu.unshift(purchaseOrderMenu);
          }
          else if (element === APP_Constants.MENU_REGISTRATION)
            newMenu.unshift(carrierMenu);
          else if (element === APP_Constants.MENU_VECHICLEORDER)
          newMenu.unshift(vechicleorderMenu);
          else if (element === APP_Constants.MENU_CANCELORDER)
            newMenu.unshift(cancelOrderMenu);
          else if (element === APP_Constants.MENU_RATELOOKUP)
            newMenu.unshift(rateEnquiryMenuDetails);
          else if (element === APP_Constants.MENU_CUSTOMER)
            newMenu.unshift(customerOnboardingMenu);
          else if (element === APP_Constants.MENU_DATAUPLOAD)
            newMenu.unshift(dataUploadMenu);
          else if (element === APP_Constants.MENU_DATAUPLOAD_CSV)
            newMenu.unshift(uploadCsvMenu);
          else if (element === APP_Constants.MENU_CONTACT_US)
            newMenu.push(contactUsDetails);  
          else if (element === APP_Constants.MENU_ADMIN_READONLY)
            newMenu.push(adminMenuDetailsRO);
          else if (element === APP_Constants.MENU_ADMIN) {
            newMenu.push(adminMenuDetails);
            newMenu.push(adminBulkUserMenuDetails);
            newMenu.push(templateMenuDetails);
            newMenu.push(trainingUploadMenu);
            newMenu.push(schemaValidationMenu);
            newMenu.push(selfConFigMenuOption)
          }
          else if (element === APP_Constants.MENU_JLR) {
            newMenu.unshift(jlrAdmin);
            newMenu.unshift(jlrOrders);
            newMenu.unshift(jlrFinance);
            newMenu.unshift(jlrSchedule);
            newMenu.unshift(jlrTransport);
            newMenu.unshift(jlrLocationandcontacts);
            newMenu.unshift(jlrpartsandpackaginglisting);
            newMenu.unshift(jlrdataupload);
          }
          else if (element === APP_Constants.MENU_VERIFY) {
            newMenu.unshift(verifyOrderMenu);
          }
          else if (element === APP_Constants.MENU_QUOTATION)
            newMenu.unshift(quotationMenu);
          else if (element === APP_Constants.MENU_LOCATION)
            newMenu.unshift(locationMenu);
          else if (element === APP_Constants.MENU_DRAFTORDER)
            newMenu.unshift(draftOrderMenu);
        });
        this.menuItems.setMenuItems(newMenu);
        if(this.menuItems) this.menuUrlArray = this.menuItems.items().map((val) => val.link);
      }
    });

    if (localStorage.getItem('portalSideMenu')) {
      let portalSideMenu = JSON.parse(localStorage.getItem('portalSideMenu'));
      let newMenu = [...APP_Constants.menuItems];
      let hasShipment = portalSideMenu.includes(APP_Constants.MENU_SHIPMENT);
      let hasMrnListing = portalSideMenu.includes(APP_Constants.MENU_MRNLISTING);
      let hasItnListing = portalSideMenu.includes(APP_Constants.MENU_ITN_LISTING);
      
      portalSideMenu.forEach(menu => {
        if (menu === APP_Constants.MENU_SHIPMENT || menu === APP_Constants.MENU_MRNLISTING || menu === APP_Constants.MENU_ITN_LISTING)
          return;
        if (menu === APP_Constants.MENU_ORDER) {
          if (hasItnListing) newMenu.unshift(itnMenu);
          if (hasMrnListing) newMenu.unshift(mrnMenu);
          if (hasShipment) newMenu.unshift(shipmentMenu);
          newMenu.unshift(ordersMenu);
        }
        else if (menu === APP_Constants.MENU_COX_ORDER) {
          // newMenu.unshift(BusinessObjectOrderUploadMenu);
          newMenu.unshift(BusinessObjectOrdersMenu);
        }
        else if (menu === APP_Constants.MENU_PURCHASEORDER)
          newMenu.unshift(purchaseOrderMenu);
        else if (menu === APP_Constants.MENU_VECHICLEORDER)
          newMenu.unshift(vechicleorderMenu);  
        else if (menu === APP_Constants.MENU_REGISTRATION)
          newMenu.unshift(carrierMenu);
        else if (menu === APP_Constants.MENU_CANCELORDER)
          newMenu.unshift(cancelOrderMenu);
        else if (menu === APP_Constants.MENU_RATELOOKUP)
          newMenu.unshift(rateEnquiryMenuDetails);
        else if (menu === APP_Constants.MENU_CUSTOMER)
          newMenu.unshift(customerOnboardingMenu);
        else if (menu === APP_Constants.MENU_DATAUPLOAD)
          newMenu.unshift(dataUploadMenu);
        else if (menu === APP_Constants.MENU_DATAUPLOAD_CSV)
          newMenu.unshift(uploadCsvMenu);
        else if (menu === APP_Constants.MENU_CONTACT_US)
          newMenu.push(contactUsDetails);  
        else if (menu === APP_Constants.MENU_ADMIN_READONLY)
          newMenu.push(adminMenuDetailsRO);
        else if (menu === APP_Constants.MENU_ADMIN) {
          newMenu.push(adminMenuDetails);
          newMenu.push(adminBulkUserMenuDetails);
          newMenu.push(templateMenuDetails);
          newMenu.push(trainingUploadMenu);
          newMenu.push(schemaValidationMenu);
          newMenu.push(selfConFigMenuOption)

        }
        else if (menu === APP_Constants.MENU_CONTACT_US)
          newMenu.push(contactUsDetails);  
        else if (menu === APP_Constants.MENU_JLR) {
          newMenu.unshift(jlrAdmin);
          newMenu.unshift(jlrOrders);
          newMenu.unshift(jlrFinance);
          newMenu.unshift(jlrSchedule);
          newMenu.unshift(jlrTransport);
          newMenu.unshift(jlrLocationandcontacts);
          newMenu.unshift(jlrpartsandpackaginglisting);
          newMenu.unshift(jlrdataupload);
        }
        else if (menu === APP_Constants.MENU_VERIFY) {
          newMenu.unshift(verifyOrderMenu);
        }
        else if (menu === APP_Constants.MENU_QUOTATION)
          newMenu.unshift(quotationMenu);
        else if (menu === APP_Constants.MENU_LOCATION)
          newMenu.unshift(locationMenu);
        else if (menu === APP_Constants.MENU_DRAFTORDER)
          newMenu.unshift(draftOrderMenu);
      });
      this.menuItems.setMenuItems(newMenu);
    }
    if (localStorage.getItem('customerCode')) {
      var cssId = 'dhlTheme';
      var head = document.getElementsByTagName('head')[0];
      var link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      if (!JSON.parse(localStorage.getItem('alwaysUseDHLTheme'))) {         // change with alwaysUseDHlTheme
        this.customerTheme = true;
        this.customerCode = localStorage.getItem('customerCode');
        link.href = '../assets/theme/' + this.customerCode + '/theme.css';
        link.media = 'all';
        head.appendChild(link);

        if (localStorage.getItem('logoD')) this.logo = localStorage.getItem('logoD');
        else this.logo = "../assets/theme/" + this.customerCode + "/logoD.jpg";
        if (localStorage.getItem('logoM')) this.logoM = localStorage.getItem('logoM');
        else this.logoM = "../assets/theme/" + this.customerCode + "/logoM.jpg";
        if (localStorage.getItem('logoS')) this.logoS = localStorage.getItem('logoS');
        else this.logoS = "../assets/theme/" + this.customerCode + "/logoS.jpg";
      } else {
        this.customerTheme = false;

        link.href = '../assets/theme/DHL/theme.css';
        link.media = 'all';
        head.appendChild(link);

        this.customerCode = localStorage.getItem('customerCode');
        this.logo = "../assets/theme/DHL/logo.svg";
      }
    }
    this.menuUrlArray = this.menuItems.items().map((val) => val.link);
    if(this.globleMessageBanner)
    {
      this.dynamicHeightOfBanner = this.globleMessageBanner.nativeElement.offsetHeight;
    }
    // NCP-15230-start Ask for cookie consent on initially login if not accepted, user won't be able to perform any action until accept the cookie consent
    setTimeout(() => {
       if(!this.cookieService.get('setConsent') || this.cookieService.get('setConsent') === "false"){
          this.showCookieBanner = true;
          this.appService.sideMenuDisable();
          if(document.getElementById("dhlApp")){
            document.getElementById("dhlApp").style.opacity = '0.6';
            document.getElementById("dhlApp").style.pointerEvents = 'none';
          }
        }
    }, 2000);
    // NCP-15230-end
  }

  onScroll(event) {
    if (this.customerThemeToolbar != undefined && this.customerThemeToolbar.nativeElement && document.getElementsByClassName('dhl-header-container-v2')[0] != undefined && this.customerThemeToolbar != null && document.getElementsByClassName('dhl-header-container-v2')[0] != null) {
      if (event.target.scrollTop > this.customerThemeToolbar.nativeElement.offsetHeight) {
        this.customerThemeToolbar.nativeElement.style.display = "none";
        (<HTMLElement>(document.getElementsByClassName('dhl-header-container-v2')[0])).style.top = "0px";
        (<HTMLElement>(document.getElementsByClassName('dhl-header-container-v2')[0])).style.transition = "all 0.7s ease";
      }
      else {
        this.customerThemeToolbar.nativeElement.style.display = "flex";
        this.customerThemeToolbar.nativeElement.style.transition = "all 0.7s ease";
        (<HTMLElement>(document.getElementsByClassName('dhl-header-container-v2')[0])).style.top = this.customerThemeToolbar.nativeElement.offsetHeight + 'px';
        (<HTMLElement>(document.getElementsByClassName('dhl-header-container-v2')[0])).style.transition = "all 0.2s linear";
      }
    }
    if (this.customerThemeToolbar != undefined && (document.getElementsByClassName('dhl-header-container-v2')[0] == undefined || document.getElementsByClassName('dhl-header-container-v2')[0] == null) && this.customerThemeToolbar != null) {
      if (event.target.scrollTop > this.customerThemeToolbar.nativeElement.offsetHeight && this.customerThemeToolbar.nativeElement) {
        this.customerThemeToolbar.nativeElement.style.display = "none";
      }
      else {
        this.customerThemeToolbar.nativeElement.style.display = "flex";
        this.customerThemeToolbar.nativeElement.style.transition = "all 0.7s ease";
      }
    }
  }

  imgaeLoadError() {
    // alert('in error');
    this.customerTheme = false;
  }

  closePopupMessge = () =>{
    this.globleMessageVisible = false;
    this.dynamicHeightOfBanner = 0;
    document.getElementById("globleMessageBanner").style.height = '0';
  }

  ngOnDestroy() {
    if (this.routerSubscription)
      this.routerSubscription.unsubscribe();
    if (this.customerSubscription)
      this.customerSubscription.unsubscribe();
    if (this.navigationSubscription)
      this.navigationSubscription.unsubscribe();
  }

  // NCP-15230-start Set cookie and user will be able to perform in application
  acceptCookies() {
    this.showCookieBanner = false;
    this.cookieService.set('setConsent', "true");
    this.appService.sideMenuEnable();
    if(document.getElementById("dhlApp")) {
      document.getElementById("dhlApp").style.opacity = '1';
      document.getElementById("dhlApp").style.pointerEvents = 'inherit';
    }
  }
  // NCP-15230-end
}

